import { PageHero } from '@/components/ui/PageHero'
import { kandakeHerbalist } from '@/assets/siteMedia'

export const ChronicHealthHero = () => (
  <PageHero
    image={kandakeHerbalist}
    imageAlt="Kandake preparing fresh herbs in her dispensary"
    highlights={['Diabetes', 'Hypertension', 'Arthritis', 'Sickle cell']}
    title="Herbal support for"
    accent="long-term conditions."
    description={
      <p>
        Support for people living with diabetes, hypertension, arthritis and sickle cell, alongside
        appropriate medical care.
      </p>
    }
  />
)
